export default {
    white: '#FFFFFF',
    // Blue
    blue100: '#003554',
    blue80: '#004B8C',
    blue60: '#156CC4',
    blue40: '#3A8DFF',
    blue10: '#E8F0F9',
    // Black
    black: '#000000',
    black80: '#404040',
    black70: '#797979',
    black60: '#929292',
    black40: '#D7D7D7',
    black20: '#EEEEEE',
    black10: '#F3F3F3',
    // Error
    error100: '#F44336',
    error10: '#FAE6E4',
    // V2 colors
    blue300: '#62AFFF',
    blue400: '#3096ff',
    blue600: '#1D5A9A',
    grey200: '#C9CED6',
    grey500: '#627187',
    grey900: '#00183C',
    cream100: '#EDEBE9',
    background: '#F7F5F3',
};
//# sourceMappingURL=colors.js.map